const convert = require('heic-convert/browser')

const JPEG_MIME_TYPE = 'image/jpeg'
const JPEG_EXTENSION = '.jpg'
const DEFAULT_JPEG_QUALITY = 0.9
const HEIC_FILE_EXTENSION_PATTERN = /\.(heic|heif)$/i
const HEIC_MIME_TYPES = [
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence',
]

function replaceFileExtensionWithJpg(fileName: string): string {
  return fileName.replace(HEIC_FILE_EXTENSION_PATTERN, JPEG_EXTENSION)
}

export function isHeicOrHeifFile(file: File): boolean {
  const fileNameMatches = HEIC_FILE_EXTENSION_PATTERN.test(file.name)
  if (fileNameMatches) {
    return true
  }

  if (!file.type) {
    return false
  }

  return HEIC_MIME_TYPES.includes(file.type.trim().toLowerCase())
}

export async function convertHeicToJpeg(
  file: File,
  quality: number = DEFAULT_JPEG_QUALITY
): Promise<File> {
  const inputBuffer = await file.arrayBuffer()

  const outputBuffer = await convert({
    buffer: new Uint8Array(inputBuffer),
    format: 'JPEG',
    quality,
  })

  const outputFileName = replaceFileExtensionWithJpg(file.name)
  const outputBlob = new Blob([outputBuffer], { type: JPEG_MIME_TYPE })

  return new File([outputBlob], outputFileName, {
    type: JPEG_MIME_TYPE,
    lastModified: file.lastModified,
  })
}
